// ── Attachment DTO ─────────────────────────────────────────────────────────────

export interface AttachmentDto {
  id:               string;
  entityName:       string;
  entityId:         string;
  originalFileName: string;
  filePath:         string;
  fileSize:         number;
  contentType:      string;
  category?:        string | null;
  remarks?:         string | null;
  uploadedBy:       string;
  uploadedByName?:  string | null;
  uploadedDate:     string;
}

// ── Audit Log DTO ──────────────────────────────────────────────────────────────

export interface AuditLogDto {
  id:          string;
  entityType:  string;
  entityId:    string;
  action:      string;
  details?:    string | null;
  changedBy:   string;
  changedByName?: string | null;
  changedDate: string;
  ipAddress?:  string | null;
}

// ── Helper ─────────────────────────────────────────────────────────────────────

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function getFileIcon(contentType: string): string {
  if (contentType.startsWith('image/'))              return '🖼';
  if (contentType === 'application/pdf')             return '📄';
  if (contentType.includes('spreadsheet') || contentType.includes('excel')) return '📊';
  if (contentType.includes('word') || contentType.includes('document'))     return '📝';
  if (contentType.startsWith('text/'))               return '📃';
  if (contentType.includes('zip') || contentType.includes('compressed'))    return '🗜';
  return '📎';
}
